import React from "react";
import Container from "../Container";
import Loading from "../Loading";
import { usePartners } from "./Hooks";

const PartenersCard = () => {
  const { data, loading } = usePartners();
  return (
    <Container
      title={"همکاران صنعتبان"}
      subtitle="شرکت هایی که صنعتبان با آن ها همکاری داشته ات"
    >
      {loading ? (
        <Loading />
      ) : (
        <div className="row">
          {data?.partners.map(pa => {
            return (
              <div className="col">
                <div className="partner-card">
                  <div>
                    <img src={pa?.logo?.url} />
                  </div>

                  <p>{pa.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Container>
  );
};

export default PartenersCard;
